// FIXME: Is this still a necessary type? (was used in old wheely)
export var FormStep;
(function (FormStep) {
    FormStep[FormStep["VEHICLES"] = 0] = "VEHICLES";
    FormStep[FormStep["COVERAGE"] = 1] = "COVERAGE";
    FormStep[FormStep["SUMMARY"] = 2] = "SUMMARY";
    FormStep[FormStep["REQUESTDATA"] = 3] = "REQUESTDATA";
    FormStep[FormStep["POLICYDATA"] = 4] = "POLICYDATA";
})(FormStep || (FormStep = {}));
export function hasValidationResultsErrors(errors, ignoreFields) {
    if (Array.isArray(errors)) {
        return errors.length > 0;
    }
    for (const key in errors) {
        if (!ignoreFields?.includes(key) &&
            hasValidationResultsErrors(errors[key])) {
            return true;
        }
    }
    return false;
}
